import React from 'react';

import classNames from 'classnames';

import { STATUS_COLOR_TYPE } from '../../types';

import './status-badge.scss';

interface StatusBadgeProps {
  color?: STATUS_COLOR_TYPE;
  title: string;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ color, title }) => (
  <div
    className={classNames('status-badge', {
      [`status-badge--${color}`]: !!color,
    })}
  >
    {title}
  </div>
);

export default StatusBadge;
